var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1998 19.1999V21.4398C19.1998 22.3359 19.1998 22.7839 19.0254 23.1261C18.872 23.4272 18.6272 23.6719 18.3261 23.8253C17.9839 23.9997 17.5358 23.9997 16.6397 23.9997H10.5594C9.66326 23.9997 9.2152 23.9997 8.87292 23.8253C8.57185 23.6719 8.32707 23.4272 8.17367 23.1261C7.99927 22.7839 7.99927 22.3359 7.99927 21.4398V15.3601C7.99927 14.4641 7.99927 14.0161 8.17367 13.6738C8.32707 13.3728 8.57185 13.128 8.87292 12.9746C9.2152 12.8003 9.66326 12.8003 10.5594 12.8003H12.7995M15.3596 19.1999H21.4399C22.336 19.1999 22.7841 19.1999 23.1263 19.0256C23.4274 18.8722 23.6722 18.6274 23.8256 18.3264C24 17.9841 24 17.5361 24 16.6401V10.5604C24 9.66432 24 9.2163 23.8256 8.87406C23.6722 8.57302 23.4274 8.32826 23.1263 8.17487C22.7841 8.00049 22.336 8.00049 21.4399 8.00049H15.3596C14.4635 8.00049 14.0154 8.00049 13.6731 8.17487C13.3721 8.32826 13.1273 8.57302 12.9739 8.87406C12.7995 9.2163 12.7995 9.66432 12.7995 10.5604V16.6401C12.7995 17.5361 12.7995 17.9841 12.9739 18.3264C13.1273 18.6274 13.3721 18.8722 13.6731 19.0256C14.0154 19.1999 14.4635 19.1999 15.3596 19.1999Z",
    stroke: "#0E9384",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/copy_dark.d36f8834ce8478225a6926cbcc9f4317.svg";
export { ForwardRef as ReactComponent };